export const ROOT_HOST = process.env.NEXT_PUBLIC_ROOT_HOST;

export const GRAPHY1_ROOT_HOST = process.env.NEXT_PUBLIC_GRAPHY1_ROOT_HOST;

export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;

export const CLOUDFRONT = process.env.NEXT_PUBLIC_CLOUDFRONT_DOMAIN;

export const SUPPORT_KEY = process.env.NEXT_PUBLIC_SUPPORT_KEY;

export const DEPLOYPENT_TYPE = process.env.DEPLOYPENT_TYPE;

export const WS_SERVICE_URI = process.env.NEXT_PUBLIC_WS_SERVICE_BASE;

export const API_BASE = process.env.NEXT_PUBLIC_API_BASE;

export const SIGNUP_API_BASE = process.env.SIGNUP_SPAYEE_API_BASE;

export const ORIGIN_TRIAL_TOKEN = process.env.NEXT_PUBLIC_ORIGIN_TRIAL_TOKEN;

export enum GRAPHY_ENVIRONMENTS {
  PRODUCTION = "production",
  BETA = "beta",
  DEVELOPMENT = "development",
}

export const IS_PRODUCTION_ENV = ENVIRONMENT === GRAPHY_ENVIRONMENTS.PRODUCTION;

export const IS_DEVELOPMENT_ENV =
  ENVIRONMENT === GRAPHY_ENVIRONMENTS.DEVELOPMENT;

export const IS_BETA_ENV = ENVIRONMENT === GRAPHY_ENVIRONMENTS.BETA;

export const SPAYEE_MANAGE_API_BASE = process.env.NEXT_PUBLIC_SPAYEE_API_BASE;

export const SPAYEE_MANAGE_API = process.env.NEXT_PUBLIC_SPAYEE_API;

export const SPAYEE_BASE_API = process.env.NEXT_PUBLIC_SPAYEE_API_NEW;

export const SPAYEE_MANAGE_TOKEN = process.env.NEXT_PUBLIC_SPAYEE_TOKEN;

export const SPAYEE_GET_DOMAIN = "t/api/creator/public/domain";

export const LEAD_CONTACT_PUBLIC = "/t/api/public/v3/lead-contact";
